import { api } from './api';

// Pair-Endpoints — verlinkt zwei Media (Hoch + Quer mit gleichem Inhalt) zu
// einem Hoch+Quer-Paar. Pair ist KEIN Gruppen-Konzept: ein Pair ist ein
// einziges Element in zwei Formaten und erscheint im UI als eine Tile.
export const pairApi = api.injectEndpoints({
  endpoints: (build) => ({
    linkPair: build.mutation({
      query: ({ id, partnerId }) => ({
        url: `element/${id}/pair`,
        method: 'POST',
        body: JSON.stringify({ partner_id: partnerId }),
      }),
      // We must invalidate the elements LIST so every consumer of
      // useGetElementsQuery — the gallery, the stream-editor element
      // picker modal, the highlights panel — re-fetches with the fresh
      // pair_id on both halves. Skipping the LIST invalidation before
      // (purely to keep the gallery's scroll position) let the stream
      // picker modal show stale rows where both halves still had
      // pair_id = null. The user could click one of the tiles thinking
      // they were picking the aggregated pair, but the stream-item ended
      // up with a single-half element_id — and depending on device
      // orientation the player never had a partner reference to fall
      // back to. The gallery still does its surgical state update on
      // success, so the operator sees the collapsed tile immediately;
      // the LIST invalidation just makes sure every other open instance
      // of the list catches up.
      invalidatesTags: (_r, _e, { id, partnerId }) => [
        { type: 'Elements', id },
        { type: 'Elements', id: partnerId },
        { type: 'Elements', id: 'LIST' },
      ],
    }),

    unlinkPair: build.mutation({
      query: (id) => ({
        url: `element/${id}/pair`,
        method: 'DELETE',
      }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Elements', id },
        { type: 'Elements', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useLinkPairMutation,
  useUnlinkPairMutation,
} = pairApi;
